import { render, staticRenderFns } from "./SamMenu.vue?vue&type=template&id=26cee405&scoped=true&"
import script from "./SamMenu.vue?vue&type=script&lang=js&"
export * from "./SamMenu.vue?vue&type=script&lang=js&"
import style0 from "./SamMenu.vue?vue&type=style&index=0&id=26cee405&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cee405",
  null
  
)

export default component.exports